exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-wrapper {\n  max-width: 380px;\n  width: 100%;\n  position: absolute;\n  top: 65px;\n  right: 5px;\n  z-index: 99999; }\n  .alert-wrapper alert {\n    width: inherit; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/alert/alert.component.sass
// module id = ../../../../../src/app/components/alert/alert.component.sass
// module chunks = main